import React from 'react';
import {
  Breadcrumb as BreadcrumbComponent,
  BreadcrumbProps,
} from '@noths/polaris-client-next-components';

import * as styles from '../styles';

export const Breadcrumb = (props: BreadcrumbProps) => (
  <div css={styles.breadcrumbWrapper}>
    <BreadcrumbComponent {...props} />
  </div>
);
